

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.C6R8FvKi.js","_app/immutable/chunks/2pkelJKV.js","_app/immutable/chunks/DdPEVikY.js","_app/immutable/chunks/DTYEGOkv.js","_app/immutable/chunks/CB2PMI89.js","_app/immutable/chunks/C5Wqr9Fc.js","_app/immutable/chunks/DkMK8g04.js","_app/immutable/chunks/B-Y5Gt5S.js","_app/immutable/chunks/BmP527wb.js"];
export const stylesheets = ["_app/immutable/assets/2.Duq9102Z.css"];
export const fonts = [];
